'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _SidebarToggleStyled = require('./styles/SidebarToggleStyled');

var _ToggleIconStyled = require('./styles/ToggleIconStyled');

var _ToggleTextStyled = require('./styles/ToggleTextStyled');

var _ToggleContentStyled = require('./styles/ToggleContentStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  toggleButtonText: _propTypes2.default.string,
  expanded: _propTypes2.default.bool,
  autoCollapsing: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  // eslint-disable-next-line react/require-default-props
  theme: _propTypes2.default.object
};
var defaultProps = {
  toggleButtonText: 'Collapse',
  expanded: false,
  autoCollapsing: false,
  onClick: _reactackleCore.noop
};

function _SidebarToggle(props) {
  return _react2.default.createElement(_SidebarToggleStyled.SidebarToggleStyled, {
    expanded: props.expanded,
    autoCollapsing: props.autoCollapsing,
    onClick: props.onClick
  }, _react2.default.createElement(_ToggleIconStyled.ToggleIconStyled, {
    expanded: props.expanded,
    autoCollapsing: props.autoCollapsing
  }, props.theme.reactackle.components.sidebar.toggleButton.iconElement), _react2.default.createElement(_ToggleContentStyled.ToggleContentStyled, null, _react2.default.createElement(_ToggleTextStyled.ToggleTextStyled, {
    expanded: props.expanded,
    autoCollapsing: props.autoCollapsing
  }, props.toggleButtonText)));
}

_SidebarToggle.propTypes = propTypes;
_SidebarToggle.defaultProps = defaultProps;
_SidebarToggle.displayName = 'SidebarToggle';
exports.default = (0, _reactackleCore.withTheme)(_SidebarToggle);